
import AddOrganization from './AddOrganization';
import ExistingOrganization from './ExistingOrganization';
import AddOrganizationAdmins from './AddOrganizationAdmins';
import OrganizationDetailsPage from './OrganizationView';
import OrganizationManagement from './OrganizationManagement';
import { authRoleAccess } from 'auth/AuthRoleAccess';


const organizationRoutes = [
  {
    path: '/organizations/add',
    component: AddOrganization,
    auth: authRoleAccess.organizations_add,
  },
  {
    path: '/organizations/existing',
    component: ExistingOrganization,
    auth: authRoleAccess.organizations_existing,
  },
  {
    path: '/organizations/admins',
    component: AddOrganizationAdmins,
    auth: authRoleAccess.organizations_admins,
    
  },
  {
    path: '/organization/:id',
    component: OrganizationDetailsPage,
    auth: authRoleAccess.organizations_admins,
  },
  {
    path: '/organizations/management',
    component: OrganizationManagement,
    auth: authRoleAccess.organizations_management,
  }
];

export default organizationRoutes;
